import type { TFunction } from "i18next";
import U2000DeleteRecordDialog from "../../../../../u2000Core/components/dialog/U2000DeleteRecordDialog";
import type { U3120CustomerContactHandler } from "./U3120CustomerContactHandlers";
import type { U3120CustomerContact } from "../../../../U3120Service";

// Typage des props du composant
interface U3120CustomerContactDeleteDlgProps {
  u3120CustomerContactHandler: U3120CustomerContactHandler;
  t: TFunction;
  NS: string;
}

function U3120CustomerContactDeleteDlg({ u3120CustomerContactHandler, t, NS }: U3120CustomerContactDeleteDlgProps) {
  if (!u3120CustomerContactHandler.isDeleteDialogOpen) return null;

  return (
    <U2000DeleteRecordDialog isOpen={u3120CustomerContactHandler.isDeleteDialogOpen} onClose={u3120CustomerContactHandler.onDlgDeleteClose} title={t("lblCustomerContact", { ns: NS })}>
      <p className="mb-4">
        {t("msgDeleteCustomerContact", {
          count: u3120CustomerContactHandler.gridStateHandlers.getSelectedRows().length,
          ns: NS,
        })}
      </p>
      <div className="mt-2 flex flex-wrap justify-center gap-x-2">
        {u3120CustomerContactHandler.gridStateHandlers.getSelectedRows().map((row: U3120CustomerContact, index: number, array: U3120CustomerContact[]) => (
          <span key={row.id} className="inline-block text-gray-800">
            {`${row.contactName || ""}`}
            {index < array.length - 1 && ", "}
          </span>
        ))}
      </div>
    </U2000DeleteRecordDialog>
  );
}

export default U3120CustomerContactDeleteDlg;
